/**
 * Which "Online Documentation" topic belongs to the page being shown.
 *
 * Port of legacy components/HeaderModals/helperModal.vue `currentComponent`:
 * the help is chosen by the CURRENT page (and product), so the profile menu
 * item opens the guide for wherever the user is. Paths are this app's
 * (basename-relative, as useLocation gives them); legacy's are in brackets.
 *
 *   page                                CCA                  EIA
 *   /manage-portfolio [manageaccounts]  ccaManagePortfolio   eiaManagePortfolio
 *   /cost-advice      [costadvice]      ccaCostAdvice        eiaCostAdvice
 *   /explorer                           explorer             —
 *   /cloud-usage-reports [cloudreports] cloudReports         —
 *   /telemetry?type=<slug>              one per connector, both products
 *
 * Not ported, because this app has no page for them yet: legacy's Billing
 * help (manageaccounts?type=billing) and List of Instances (that view is
 * shown on Manage Portfolio here, whose own guide applies).
 * Legacy also listed Login / Home / RegionsList, which it never registered —
 * they opened an EMPTY dialog. Here a page without a topic has none, and the
 * menu leaves the item out (headerActions.js).
 *
 * Pure: no React, no router — the caller passes the location in.
 */

/** Telemetry slug (legacy `?type=`) -> topic. */
const TELEMETRY_TOPICS = Object.freeze({
  datadog: 'datadog',
  cloudwatch: 'cloudwatch',
  azureinsights: 'azureInsights',
  gcptelemetry: 'gcpTelemetry',
  prometheus: 'prometheus',
});

/** Page path -> topic, per product. */
const PAGE_TOPICS = Object.freeze({
  cca: Object.freeze({
    '/manage-portfolio': 'ccaManagePortfolio',
    '/cost-advice': 'ccaCostAdvice',
    '/explorer': 'explorer',
    '/cloud-usage-reports': 'cloudReports',
  }),
  eia: Object.freeze({
    '/manage-portfolio': 'eiaManagePortfolio',
    '/cost-advice': 'eiaCostAdvice',
  }),
});

/**
 * @param {{ pathname: string, search?: string, mode: 'cca'|'eia' }} where
 * @returns {string | null} the topic id, or null when this page has no help
 */
export function helpTopicFor({ pathname, search = '', mode }) {
  const path = String(pathname ?? '').replace(/\/+$/, '') || '/';
  if (path === '/telemetry') {
    const type = new URLSearchParams(search).get('type')?.toLowerCase() ?? '';
    return TELEMETRY_TOPICS[type] ?? null;
  }
  return PAGE_TOPICS[mode]?.[path] ?? null;
}
